import React from 'react';
import ReactPlayer from 'react-player';
import { SkeletonImage } from '../Photos/SkeletonImage';

export type MediaType = 'image' | 'video';

export interface MediaPlayerProps {
  type: MediaType;
  src: string;
  alt?: string;
  className?: string;
  containerClassName?: string;
  controls?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
  loop?: boolean;
  width?: string | number;
  height?: string | number;
  onPlay?: () => void;
  onPause?: () => void;
  onEnded?: () => void;
}

const MediaPlayer: React.FC<MediaPlayerProps> = ({
  type,
  src,
  alt = 'Media content',
  className = '',
  containerClassName = '',
  controls = true,
  autoPlay = false,
  muted = false,
  loop = false,
  width = '100%',
  height = '100%',
  onPlay,
  onPause,
  onEnded
}) => {
  if (type === 'image') {
    return (
      <div className={`relative ${containerClassName}`}>
        <SkeletonImage
          src={src}
          alt={alt}
          className="min-h-96 w-full"
          imgClassName={`w-full h-full object-cover ${className}`}
        />
      </div>
    );
  }

  // type === 'video'
  return (
    <div className={`relative ${containerClassName}`}>
      <ReactPlayer
        {...({
          src,
          width,
          height,
          playing: autoPlay,
          controls,
          muted,
          loop,
          onPlay,
          onPause,
          onEnded,
          className,
          style: { objectFit: 'cover' }
        } as any)}
      />
    </div>
  );
};

export default MediaPlayer;
